import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/management/Home.vue'
import {authenticationGuard} from '@/router/authenticationGuard';
import AuthRedirect from "@/views/AuthRedirect.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/authRedirect',
        name: 'authRedirect',
        component: AuthRedirect,
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: 'start',
        beforeEnter: authenticationGuard,
        children: [
            {
              path:'/map',
              name: 'map',
                component: () => import(/* webpackChunkName: "learning" */ '../views/maps/progressMap.vue')
            },
            {
                path: '/start',
                name: 'Start',
                component: () => import(/* webpackChunkName: "mgm" */ '../views/management/Start.Splash.vue')
            },
            {
                path: '/about',
                name: 'About',
                component: () => import(/* webpackChunkName: "mgm" */ '../views/management/About.vue')
            },
            {
                path: '/profile',
                name: 'Profile.vue',
                component: () => import(/* webpackChunkName: "mgm" */ '../views/management/Profile.vue'),
                beforeEnter: authenticationGuard
            },
            {
                path: '/trainee/:id/statistic',
                name: 'TraineeStatistics',
                component: () => import(/* webpackChunkName: "mgm" */ '../views/trainees/trainee.statistic.vue'),
                beforeEnter: authenticationGuard
            }
        ]
    },
    {
        path: '/learning',
        name: 'learningLayout',
        component: () => import(/* webpackChunkName: "learning" */ '../views/learn/learn.layout.vue'),
        beforeEnter: authenticationGuard,
        children: [
            {
                path: 'trainee/:id',
                name: 'traineeLearningLayout',
                component: () => import(/* webpackChunkName: "learning" */ '../views/learn/learn.trainee.layout.vue'),
                beforeEnter: authenticationGuard,
                children: [
                    {
                        path: 'start',
                        name: "traineeLearningStart",
                        component: () => import(/* webpackChunkName: "learning" */ '../views/learn/learn.start.vue'),
                        beforeEnter: authenticationGuard
                    },
                    {
                        path:'math',
                        name:"learningMath",
                        component: () => import(/* webpackChunkName: "learning" */ '../views/learn/learn.math.vue'),
                        beforeEnter: authenticationGuard
                    },
                    {
                        path: 'completed',
                        name: "traineeLearningComplete",
                        component: () => import(/* webpackChunkName: "learning" */ '../views/learn/learn.math.complete.vue'),
                        beforeEnter: authenticationGuard
                    },
                ]

            }
        ]

    },
    {
        path: '/trainees',
        name: 'trainees',
        component: () => import(/* webpackChunkName: "trainee" */ '../views/trainees/trainee.Layout.vue'),
        beforeEnter: authenticationGuard,
        children:
            [
                {
                    path: '/profile/:id',
                    name: "trainee.profile",
                    component: () => import(/* webpackChunkName: "trainee" */ '../views/trainees/trainee.profile.vue'),
                    beforeEnter: authenticationGuard
                }
                ,
                {
                    path: 'create',
                    name: 'trainee.create',
                    component: () => import(/* webpackChunkName: "trainee" */ '../views/trainees/trainee.create.vue'),
                    beforeEnter: authenticationGuard
                }
            ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
